import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { cn } from '../lib/utils';

const getInitials = (name) => (name ? name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2) : 'U');

export const UserAvatar = ({ user, className, fallbackClassName, testId = 'user-avatar' }) => (
  <Avatar className={className} data-testid={testId}>
    {user?.picture && (
      // Google photo URLs reject requests that carry a referrer
      <AvatarImage
        src={user.picture}
        alt={`${user?.name || 'User'}'s profile photo`}
        referrerPolicy="no-referrer"
        className="object-cover"
        data-testid={`${testId}-image`}
      />
    )}
    <AvatarFallback className={cn('bg-emerald-600 text-white', fallbackClassName)} aria-label={user?.name} data-testid={`${testId}-initials`}>
      {getInitials(user?.name)}
    </AvatarFallback>
  </Avatar>
);

export default UserAvatar;
